import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../../helpers';
import ListadoParticipantesComponent from './ListadoParticipantes';

const DetallesEventosComponent = () => {
  const eventosStore = Redux.useSelector((state) => state.eventos);

  return (
    eventosStore.activo && (
      <Grid container spacing={1}>
        <Grid item md={4}>
          <Typography variant="h5" fontWeight="bold">
            {eventosStore.activo.nombre}
          </Typography>
          <br />
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Fecha de inicio: </strong>
            <br />
            {dateformat(eventosStore.activo.inicio, {
              format: 'dddd, DD-MM-YYYY hh:mm a',
            })}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Fecha de finalización: </strong>
            <br />
            {dateformat(eventosStore.activo.fin, {
              format: 'dddd, DD-MM-YYYY hh:mm a',
            })}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Evento pùblico: </strong>
            {eventosStore.activo.public ? 'Sí' : 'No'}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Descripción: </strong>
            <br />
            {eventosStore.activo.desc}
          </Typography>
          <Typography
            sx={{ mt: 5 }}
            variant="h6"
            fontWeight="bold"
            textAlign="center"
          >
            <Typography fontSize="30pt" fontWeight="bold" textAlign="center">
              {eventosStore.activo.participantes.length}
            </Typography>
            Participantes
          </Typography>
        </Grid>
        <Grid item md={8}>
          <ListadoParticipantesComponent />
        </Grid>
      </Grid>
    )
  );
};

export default DetallesEventosComponent;
